var wishlAppJavaScript = function (t, e, i, n, s) {
    "use strict";
    /**
     * Cookie plugin
     *
     * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
     * Dual licensed under the MIT and GPL licenses:
     * http://www.opensource.org/licenses/mit-license.php
     * http://www.gnu.org/licenses/gpl.html
     *
     */
    t.cookie = function (e, i, s) {
        if ("undefined" == typeof i) {
            var a = null;
            if (n.cookie && "" != n.cookie)
                for (var o = n.cookie.split(";"), r = 0; r < o.length; r++) {
                    var l = t.trim(o[r]);
                    if (l.substring(0, e.length + 1) == e + "=") {
                        a = decodeURIComponent(l.substring(e.length + 1));
                        break
                    }
                }
            return a
        }
        s = s || {}, null === i && (i = "", s.expires = -1);
        var d = "";
        if (s.expires && ("number" == typeof s.expires || s.expires.toUTCString)) {
            var c;
            "number" == typeof s.expires ? (c = new Date, c.setTime(c.getTime() + 24 * s.expires * 60 * 60 * 1e3)) : c = s.expires, d = "; expires=" + c.toUTCString()
        }
        var u = s.path ? "; path=" + s.path : "",
                h = s.domain ? "; domain=" + s.domain : "",
                f = s.secure ? "; secure" : "";
        n.cookie = [e, "=", encodeURIComponent(i), d, u, h, f].join("")
    };
    /**
     * Wishl - Wish List Shopify app
     *
     * Copyright (c) 2015 Lucas Lessa LLC (lucaslessa.com)
     * All Rights Reserved.
     *
     * Contains bits of https://github.com/carolineschnapp/recently-viewed/
     * Module to show Recently Viewed Products
     *
     * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
     * Dual licensed under the MIT and GPL licenses:
     * http://www.opensource.org/licenses/mit-license.php
     * http://www.gnu.org/licenses/gpl.html
     *
     */
    var a = "wishl-",
            o = "#" + a + "wrapper",
            r = "." + a + "add-wrapper,#" + a + "add-wrapper",
            l = "/" + a + "wishlist",
            d = i.location.pathname,
            c = {
                app_host: "https://favorites-wishlist.herokuapp.com",
                asset_host: "",
                storeId: null,
                wishlist: {
                    id: null,
                    title: null,
                    token: null
                },
                shown: 0,
                allItems: {},
                itemsQueue: [],
                handlebars: null,
                handlebars_ready: !1,
                cssLoaded: !1,
                jst: {
                    item: 0,
                    note: 0
                },
                customer: {
                    id: null,
                    email: null
                },
                canLogIn: !0,
                prefs: {
                    btn: 0,
                    btn_icon: null,
                    btn_icon_color: "",
                    btn_icon_color_in: "",
                    btn_text: "Add to Wishlist",
                    btn_text_in: "View in Your Wishlist",
                    btn_size: null,
                    btn_class: null,
                    show_addtocart_btn: !0,
                    display: "list",
                    url: "/a" + l,
                    disabled: !1,
                    add_to_cart_text: "Add to Cart",
                    show_sold_out: !1,
                    delete_text: "delete",
                    default_title: "My Wishlist"
                },
                pagination: null,
                wrapper: o,
                hasProduct: !1,
                onProduct: !1,
                onWishlist: !1,
                productHandle: null,
                prevGetAll: !1,
                vInterval: 0,
                xdr: 0,
                setLang: function (e) {
                    var n = {
                        _lang: "en",
                        add_to_wishlist: "Add to Wishlist",
                        button_create_list: "Create",
                        cancel: "Cancel",
                        edit_title: "Edit Title",
                        in_wishlist: "In Your Wishlist",
                        item_alert_variant_unavailable: "Product unavailable with selected options - try choosing a different option",
                        item_duplicate_error: "Item is already present in that list.",
                        item_sold_out: "Sold Out",
                        list_continue_shopping: "Continue shopping",
                        list_created_date: "created {{ created_date }}",
                        list_delete: "Delete",
                        list_item_count: "{{ item_count }} item(s)",
                        list_loading: "List loading...",
                        list_default_list: "Default list",
                        list_no_items: "No items in your list.",
                        list_or_log_in_view_saved: "or {{ login_link }} to view your saved lists",
                        log_in_dropdown: "{{ log_in_link }} to use multiple lists.",
                        log_in_link: "Log in",
                        log_in_save_list: "{{ log_in_link }} to save this list.",
                        log_in_view_all: "{{ log_in_link }} to view all of your lists.",
                        move: "Move",
                        note: "Note",
                        note_add: "Add Note",
                        note_edit: "Edit Note",
                        page: "Page",
                        prompt_list_title_edit: "Enter a new title for {{ old_title }}",
                        prompt_list_title_create: "Enter a List Title",
                        save: "Save",
                        saved_list: "{{ list.title }} has been saved to your account.",
                        service_error_connection: "There was an error connecting to the Favorites Wishlist service. Please wait a few seconds and try again or reload the page.",
                        service_error_maintenance: "Favorites Wishlist service is temporarily unavailable. Please wait a few seconds and try again or reload the page.",
                        service_not_enabled: "Favorites Wishlist service is not enabled for this shop",
                        share_list_label: "Share this list:",
                        shorten_link: "Shorten link",
                        shorten_link_error: "Unable to shorten link",
                        tab_new_list: "New List",
                        tab_share: "Share",
                        tab_your_lists: "Your Lists",
                        shared_list_view_own_link: "Click here to view your own list.",
                        shared_list_warning: "You are viewing a shared list."
                    };
                    c.langStrings = e ? t.extend({}, n, e) : n, c.loginLink = '<a href="/account/login?checkout_url=' + encodeURIComponent(i.location.href) + '">' + c.t("log_in_link") + "</a>"
                },
                t: function (t) {
                    var e = c.langStrings || {},
                            i = [],
                            n = e[t] || "",
                            s = /\{\{[a-z_. ]+\}\}/g,
                            a = s.test(n),
                            o = n;
                    if (a) {
                        for (var r = 1, l = arguments.length; l > r; r++)
                            i.push(arguments[r]);
                        i.length ? o = o.replace(s, function () {
                            return i.shift()
                        }) : console.log("Missing interpolation values in lang call")
                    }
                    return o
                },
                setDefaults: function () {
                    var e = "/products/",
                            i = function (e, i) {
                                return t(e).length > 0 || d.indexOf(i) > -1
                            };
                    return c.onProduct = i("", e), (c.hasProduct = i(r, e)) && (c.productHandle = t(r).data("productHandle") || d.match(/\/products\/([a-z0-9\-]+)/)[1] || null), c.onWishlist = i(o, l), c.setLang(), !0
                },
                buildRequestUrl: function (t, e) {
                    var i = [],
                            n = c.app_host,
                            s = "item",
                            a = s + "s",
                            o = "wishlist",
                            r = o + "s",
                            l = "store",
                            d = l + "s";
                    switch (e = "undefined" != typeof e && +e > 0 ? +e : null, t) {
                        case s:
                            if (!e)
                                break;
                            i.unshift(e);
                        case a:
                            if (i.unshift(a), t !== a)
                                break;
                        case o:
                            i.unshift(e ? e : c.getWishlistId());
                        case r:
                            if (i.unshift(r), t !== r)
                                break;
                        case l:
                            i.unshift(e && t === l ? e : c.getStoreId());
                        case d:
                            i.unshift(d);
                            break;
                        default:
                            i = ["full"]
                    }
                    return i.length > 0 ? (c.xdr && (n = n.replace("https:", "")), i.unshift(n), i.join("/")) : null
                },
                cookie: {
                    configuration: {
                        expires: 90,
                        path: "/",
                        domain: i.location.hostname
                    },
                    name: "_wishl_",
                    write: function (e) {
                        "object" == typeof e && e.token !== s && t.cookie(this.name, e.token, this.configuration)
                    },
                    read: function () {
                        return t.cookie(this.name)
                    },
                    destroy: function () {
                        t.cookie(this.name, null, this.configuration)
                    }
                },
                loggedIn: function () {
                    return !(!c.customer.id || !c.customer.email)
                },
                readParamFromURL: function (t) {
                    for (var e = i.location.search.substring(1), n = e.split("&"), s = 0, a = n.length; a > s; s += 1) {
                        var o = n[s].split("=");
                        if (o[0] === t)
                            return o[1]
                    }
                    return null
                },
                err: function (t, e, i) {
                    var n, s;
                    console.log("Wishl error", i, t, e), c.hasProduct || (n = 0 === t.status ? "service_error_maintenance" : "service_error_connection", s = c.t(n), c.onWishlist && (c.setLoadingState(1), c.statusMsg(0, s)), console.log(s, n))
                },
                registerList: function (t) {
                    t.id && 0 === t.token.search(/[0-f]{32}/) ? (c.wishlist = t, c.cookie.write(t)) : console.log("Warning: invalid wishlist object")
                },
                ajax: function (e, i, n, s) {
                    var a = {
                        type: n ? "POST" : "GET",
                        dataType: "json",
                        url: e,
                        data: i,
                        global: !1
                    };
                    return s && t.extend(a, s), t.ajax(a)
                },
                post: function (e, i, n) {
                    return n && t.extend(i, {
                        _method: n
                    }), c.ajax(e, i, 1)
                },
                getAll: function (e) {
                    function n(e) {
                        var i, n = e.store || !1,
                                u = e.wishlists || [],
                                f = e.items || {};
                        return o ? (c.storeId = n.id, t.extend(c.prefs, e.preferences), a(e.languages || []), c.lists.all = u, c.allItems = s(f, u), i = r(u, g, h), l(i, h), void d()) : !1
                    }

                    function s(t, e) {
                        var i, n, s = {};
                        for (i = e.length - 1; i >= 0; i--)
                            s[e[i].id] = [];
                        for (t[0] && t[0].id ? (n = function (t, e) {
                            t[e.wishlist_id].push(e)
                        }, t.sort(function (t, e) {
                            return t.id - e.id
                        })) : n = function (t, e) {
                            t[e[0]].push(e[1])
                        }, i = t.length - 1; i >= 0; i--)
                            n(s, t[i]);
                        return s
                    }

                    function a(t) {
                        var e = t.length,
                                n = 0;
                        if (e > 1 && "string" == typeof i.wishl_set_lang_code)
                            for (; e > n && t[n].code !== i.wishl_set_lang_code; n++)
                                ;
                        e > 0 && c.setLang(t[n].translations)
                    }

                    function o(t, e, i) {
                        return t && e && e.id ? !0 : (msgtext = c.t("service_not_enabled"), i && (c.setLoadingState(1), c.statusMsg(0, msgtext)), console.log("Wishl: " + msgtext), !1)
                    }

                    function r(t, e, i) {
                        var n = t[0] || !1,
                                s = 0,
                                a = t.length;
                        if (e && !i) {
                            for (; a > s; s += 1)
                                if (t[s].token === e) {
                                    n = t[s];
                                    break
                                }
                            n || (console.log("Wishl: destroy cookie with lame token"), c.cookie.destroy())
                        }
                        return n
                    }

                    function l(t, e) {
                        var i;
                        t && e ? (c.wishlist = t, i = c.t("shared_list_warning") + ' <a href="' + c.prefs.url + '">' + c.t("shared_list_view_own_link") + "</a>", c.statusMsg(2, i)) : t && (c.registerList(t), _ && !t.customer_id && c.claimList())
                    }

                    function d() {
                        e ? c.getItems() : c.placeButton()
                    }

                    function u(e, i) {
                        var n = t.param(e);
                        return c.prevGetAll === n ? (!i && c.storeId && c.placeButton(), !0) : (c.prevGetAll = n, !1)
                    }
                    var h = "shared",
                            f = c.readParamFromURL(h),
                            p = c.readParamFromURL("saved"),
                            g = p || c.cookie.read(),
                            m = c.buildRequestUrl(),
                            _ = c.loggedIn(),
                            v = {
                                shop: "favorites-wishlist.myshopify.com"
                            };
                    return e && f ? (m += "/" + h, v.share_token = f) : (h = !1, g && (v.token = g)), e && (v.full = 1), _ && t.extend(v, {
                        customer: c.customer
                    }), u(v, e) ? void 0 : c.ajax(m, v).done(n).fail(c.err)
                },
                getStoreId: function () {
                    return c.storeId || c.ajax(c.buildRequestUrl("stores"), {
                        shop: "favorites-wishlist.myshopify.com"
                    }).done(function (e) {
                        var i = e.store.id || !1;
                        if (c.storeId = i) {
                            if (t.extend(c.prefs, e.preferences), c.prefs.disabled === !0)
                                return !1;
                            c.onWishlist ? c.getItems() : c.placeButton()
                        }
                        return i
                    }).fail(c.err), c.storeId
                },
                getWishlistId: function (e) {
                    if (!c.wishlist.id) {
                        var i, n = this.readParamFromURL("saved"),
                                s = c.cookie.read() || n,
                                a = c.buildRequestUrl("wishlists"),
                                o = c.loggedIn(),
                                r = o ? {
                                    customer: c.customer
                                } : {};
                        e = e || t.noop, s ? c.ajax(a, t.extend({
                            token: s
                        }, r)).done(function (t) {
                            return c.registerList(t), i = t.items_count > 0 && !t.customer_id, console.log(c.wishlist.id, t, i, s, n), o && t.customer_id && t.customer.shop_customer_id != c.customer.id ? c.getWishlistId(e) : void(o && i ? c.claimList() : e())
                        }).fail(function (t, i, n) {
                            404 === t.status ? (console.log("Wishlist not found with cookie token. Erasing cookie and trying again."), c.cookie.destroy(), c.getWishlistId(e)) : c.err(t, i, n)
                        }) : o ? c.ajax(a, r).done(function (t) {
                            c.registerList(t), console.log("customer", c.customer, c.wishlist.id), e()
                        }).fail(function (t, i, n) {
                            404 === t.status ? (console.log("Wishlist not found with customer info. Creating new wishlist."), c.create(e)) : c.err(t, i, n)
                        }) : c.storeId && c.create(e)
                    }
                    return c.wishlist.id
                },
                claimList: function () {
                    var t = {
                        customer: c.customer
                    };
                    c.patch(t, function (t) {
                        var e = c.t("saved_list", "<i>" + t.title + "</i>");
                        c.lists.remove(t.id, !0).add(t).multilist(), c.statusMsg(1, e)
                    })
                },
                lists: {
                    all: [],
                    add: function (t) {
                        return this.all.unshift(t), this.select(t.id)
                    },
                    remove: function (e, i) {
                        return this.action(e, function (n) {
                            return t("#wishl-multilist-" + e).remove(), this.all.splice(n, 1), i || +e !== c.wishlist.id ? void 0 : this.all[0] ? this.select(this.all[0].id) : c.setLoadingState(0)
                        })
                    },
                    replace: function (t, e) {
                        return this.action(t, function (t) {
                            this.all[t] = e
                        })
                    },
                    register: function (t) {
                        return this.action(t, function (t) {
                            c.registerList(this.all[t])
                        })
                    },
                    select: function (t) {
                        return this.action(t, function () {
                            this.register(t), c.upgradeHbs(), c.getItems({
                                switchList: !0
                            }), c.clearMsg()
                        })
                    },
                    action: function (t, e) {
                        var i = this.indexOfList(t);
                        return i > -1 && e.call(this, i), this
                    },
                    indexOfList: function (t) {
                        for (var e = 0, i = this.all.length; i > e; e += 1)
                            if (this.all[e].id === +t)
                                return e;
                        return -1
                    },
                    multilist: function () {
                        var e, i, n, s, a, o, r = "",
                                l = "multi-wishlists",
                                d = t("#" + l),
                                u = this.all,
                                h = !c.loggedIn(),
                                f = 0,
                                p = h ? 0 : u.length,
                                g = c.wishlist,
                                m = l + "-tab",
                                _ = "#" + m,
                                v = '<div id="' + m + '"></div>',
                                w = "wishl-multilist-",
                                b = w + "title",
                                I = "list-delete";
                        if (!c.canLogIn)
                            return this;
                        for (; p > f; f += 1) {
                            if (e = u[f], !e.token)
                                return this;
                            n = c.t("list_item_count", e.items_count), i = new Date(e.created_at), i = c.t("list_created_date", i.toLocaleDateString()), s = '<a href="#" class="' + I + '" data-action="delete">' + c.t("list_delete") + "</a>", r += '<li id="' + w + e.id + '" data-list-id="' + e.id + '"><a class="' + b + '" data-action="switch" href="#">' + e.title + '</a> <span class="' + w + 'info">' + [n, i, s].join(" / ") + "</span>"
                        }
                        return p > 0 && (d.length < 1 && (d = t('<ul id="' + l + '">').on("click", "." + b + ",." + I, function () {
                            var e, i = t(this).closest("li"),
                                    n = i.data("listId"),
                                    s = t(this).data("action");
                            return console.log("clicked multilist", n, s), n && ("delete" == s ? (e = i.find("." + b).eq(0).text(), confirm('Delete "' + e + '"?') && c.destroy(n)) : (c.lists.select(n), c.controls.toggleTab(_))), !1
                        }), o = t(v).hide().append(d)), d.html(r)), h && g.customer_id && g.token && (a = !c.prefs.default_tab, o = t(v).hide().html(c.t("log_in_view_all", c.loginLink))), o && (c.controls.addTab(c.t("tab_your_lists"), _, o, "folder-open"), a && c.controls.toggleTab(_)), this
                    },
                    dropdown: function (e, i) {
                        var n, s, a = this.all,
                                o = "move" === e,
                                l = t(i),
                                d = t('<li><a class="add-to-wishl" href="#"></a></li>'),
                                u = 0,
                                h = a.length,
                                f = "wishl-list-default",
                                p = c.wishlist.token || "",
                                g = o ? "" : c.buttonIcon() + " ",
                                m = {},
                                _ = c.canLogIn;
                        if (!c.loggedIn())
                            return _ ? l.append('<li class="not-logged-in">' + c.t("log_in_dropdown", c.loginLink) + "</li>") : l.remove(), _;
                        for (o || (m = l.closest(r).data()); h > u; u += 1)
                            n = a[u], n.token && (t.extend(m, {
                                listId: n.id,
                                listToken: n.token
                            }), s = d.clone(), t("a", s).html(g + n.title).data(m), n.token === p && s.addClass(f), l.append(s))
                    },
                    addNewListTab: function () {
                        var e, i, n = "add-new-list",
                                s = "#" + n,
                                a = n + "-title",
                                o = t('<div id="' + n + '"></div>');
                        return c.loggedIn() && c.wishlist.token && t(s).length < 1 && (e = c.t("prompt_list_title_create"), i = c.t("button_create_list"), o.hide().html('<input type="text" id="' + a + '" placeholder="' + e + '">'), t('<input type="button" class="btn btn-default btn-sm" value="' + i + '">').appendTo(o).click(function () {
                            var e = t("#" + a),
                                    i = e.val();
                            c.create(function () {
                                c.controls.toggleTab(s), c.lists.multilist()
                            }, i)
                        }), c.controls.addTab(c.t("tab_new_list"), s, o, "plus")), this
                    }
                },
                selectedVariantId: function () {
                    function e(e) {
                        var a = e.parent(),
                                o = a.data("productId"),
                                r = t("form[action='/cart/add']"),
                                l = "select,input[type='radio']",
                                d = !/atomic/.test(a.data("adder"));
                        this.$btn = e, this.$cartForm = s(r, o), this.selectors = l, this.$idField = n(this.$cartForm).filter(l + ":checked,input[type='hidden']"), this.variantId = i(a, this.$idField, d)
                    }

                    function i(t, e, i) {
                        var n = t.data("variantId"),
                                s = i && e.not(":disabled").val();
                        return s || n
                    }

                    function n(e) {
                        return t("[name='id']", e)
                    }

                    function s(e, i) {
                        function n() {
                            var e = t(this);
                            return e.data("productId") === i || e.is("[id$='-" + i + "']")
                        }
                        var s;
                        return s = i && e.filter(n), s && 1 === s.length || (s = e.filter(a)), s
                    }

                    function a() {
                        function e(t, e) {
                            (+e.value || e.disabled) && (s = !0)
                        }
                        var i = n(this),
                                s = !1;
                        return "SELECT" === i.prop("tagName") && (i = t(">option", i)), i.each(e), s
                    }

                    function o(e, i, n) {
                        function s() {
                            var t = this.form.elements.id,
                                    e = t.value,
                                    i = t.disabled || !e;
                            c.setButtonStateAll(i ? null : e, n)
                        }
                        var a = "change";
                        t(i, e).on(a, s)
                    }

                    function r(t) {
                        c.vInterval && clearInterval(c.vInterval), c.onProduct && (c.vInterval = setInterval(function () {
                            t.eq(0).triggerHandler("change")
                        }, 1e3))
                    }
                    return e.prototype.get = function () {
                        return this.variantId
                    }, e.prototype.watchVariantChange = function () {
                        o(this.$cartForm, this.selectors, this.$btn)
                    }, e.prototype.pollVariantChange = function () {
                        r(this.$idField)
                    }, e
                }(),
                addItem: function (e) {
                    if (e && e.preventDefault(), c.hasProduct) {
                        var i, n, s = t(this),
                                a = s.data(),
                                o = a.listId || !1,
                                r = c.wishlist.id || !1,
                                l = c.wishlist.token || !1,
                                d = a.isInList,
                                u = "click",
                                h = new c.selectedVariantId(s),
                                f = function () {
                                    s.on(u, c.addItem)
                                },
                                p = function () {
                                    var e = {};
                                    return t("[name^='properties']", h.$cartForm).each(function () {
                                        var i, n = t(this),
                                                s = n.attr("name").match(/\[(.+)\]/),
                                                a = n.val();
                                        (!n.is(":radio, :checkbox") || n.is(":checked")) && "" !== a && s && (i = s[1]) && "" !== i && (e[i] = a)
                                    }), e
                                };
                        s.off(u).on(u, !1), o && o !== r && (r = o, l = a.listToken, i = !0), d || c.setButtonState(2, s), d ? (i && c.lists.register(r), location.href = c.prefs.url) : r ? (n = h.get()) ? c.post(c.buildRequestUrl("items", r), {
                            store_id: c.storeId,
                            token: l,
                            item: {
                                handle: a.productHandle || c.productHandle,
                                variantid: n,
                                productid: a.productId || "",
                                properties: p()
                            }
                        }).done(function (t) {
                            var e = t.variantid || n;
                            c.allItems[r].unshift(e), c.setButtonStateAll(e, s), s.blur()
                        }).fail(function (t) {
                            console.log(t)
                        }).always(f) : (alert(c.t("item_alert_variant_unavailable")), f()) : c.create(t.proxy(c.addItem, s))
                    }
                },
                removeItem: function (e, i) {
                    var n = c.wishlist,
                            s = n.id,
                            a = n.token,
                            o = +i && c.loggedIn(),
                            r = c.buildRequestUrl("item", e) + (o ? "/move" : ""),
                            l = {
                                store_id: c.storeId,
                                wishlist_id: s
                            };
                    if (+e > 0 && s && (o || a)) {
                        if (o && i === s)
                            return !0;
                        t.extend(l, o ? {
                            target_list: i,
                            customer: c.customer
                        } : {
                            token: a
                        }), c.post(r, l, o ? !1 : "delete").done(function (a) {
                            var r, l = "#wishl-item-" + e;
                            c.itemErr(a, l, "") || (o && (c.allItems[i].unshift(a), r = c.lists.indexOfList(i), c.lists.all[r].items_count += 1), t(l).fadeTo(600, 0, function () {
                                t(this).slideUp(function () {
                                    t(this).remove()
                                })
                            }), c.listItemDo(e, s, function (t, e) {
                                o && (a.note = e[t].note), e.splice(t, 1)
                            }), c.shown -= 1, n.items_count -= 1, c.loggedIn() && c.lists.multilist(), c.shown < 1 && (n.items_count < 1 ? c.setLoadingState(0) : (c.upgradeHbs(), c.getItems({
                                page: 1
                            }))))
                        }).fail(c.err)
                    } else
                        console.log("Invalid Wishlist item ID", e)
                },
                moveItem: function () {
                    var e = t(this),
                            i = e.closest("div").find(".wishl-move-item").data("item"),
                            n = e.data("listId");
                    return +i && +n && c.loggedIn() && c.removeItem(i, n), !1
                },
                create: function (t, e) {
                    return e = e || c.t("list_default_title") || c.prefs.default_title, c.wishlist.id && !c.loggedIn() ? void console.log("Not creating new list. User already has a list, not logged in") : c.post(c.buildRequestUrl("wishlists"), {
                        wishlist: {
                            title: e,
                            customer: c.customer
                        }
                    }).done(function (e) {
                        c.onWishlist && e.customer_id ? c.lists.add(e) : c.registerList(e), c.allItems[e.id] = [], t()
                    }).fail(c.err)
                },
                patch: function (t, e, i) {
                    function n(t) {
                        t.token && (c.registerList(t), c.lists.replace(t.id, t), "function" == typeof e && e(t))
                    }
                    var s, a, o, r = c.wishlist;
                    if (r.token && "object" == typeof t)
                        return i = i || c.err, s = c.buildRequestUrl("wishlist", r.id), a = {
                            store_id: c.storeId,
                            token: r.token,
                            wishlist: t
                        }, o = c.post(s, a, "patch"), o.done(n).fail(i), o
                },
                rename: function (e) {
                    return c.patch({
                        title: e
                    }, function (e) {
                        var i = "wishl-multilist-",
                                n = "#wishl-title, #" + i + e.id + " ." + i + "title";
                        t(n).removeClass("wishl-working").html(e.title), c.sharingTab()
                    })
                },
                destroy: function (t) {
                    t = +t, t > 0 && c.loggedIn() && c.post(c.buildRequestUrl("wishlist", t), {
                        store_id: c.storeId,
                        customer: c.customer
                    }, "delete").done(function () {
                        c.lists.remove(t)
                    }).fail(c.err)
                },
                setNote: function (e, i, n, s) {
                    var a, o = c.wishlist,
                            r = o.id,
                            l = "item" === e,
                            d = "wishlist" === e,
                            u = {
                                store_id: c.storeId,
                                token: o.token,
                                wishlist_id: r,
                                content: n
                            };
                    return i = +i, i && (l || d) && (a = c.buildRequestUrl(e, +i) + "/set_note", c.post(a, u).done(function (n) {
                        var a = ".wishl-note",
                                o = l ? "#wishl-item-" + i : 0;
                        return c.itemErr(n, o, c.t("note")) ? s() : (t(a + "-content", a + "[data-type=" + e + "][data-item=" + i + "]").html(n.content), l && c.listItemDo(i, r, function (t, e) {
                            e[t].note = n
                        }), d && (c.lists.all[c.lists.indexOfList(i)].note = n), void s(1))
                    }).fail(c.err)), !1
                },
                listItemDo: function (t, e, i) {
                    for (var n = c.allItems[e] || [], s = 0; s < n.length; s += 1)
                        if (+t === n[s].id)
                            return i(s, n)
                },
                itemErr: function (t, e, i) {
                    var n, s, a = "errors",
                            o = a in t,
                            r = t.lang_key;
                    if (o && e) {
                        if (a = t[a], "object" == typeof a) {
                            n = [];
                            for (s in a)
                                n.push(i + " " + s + " " + a[s]);
                            n = n.join("<br/>")
                        } else
                            n = r && c.t(r) || a;
                        c.statusMsg(0, n, e, !0, !0)
                    }
                    return o
                },
                buttonIcon: function (t) {
                    var e = c.prefs.btn_icon,
                            i = e;
                    return e && t === !0 && (i += " isin"), e ? '<i class="wishl-icon ' + i + '"/>' : ""
                },
                placeButton: function () {
                    if (!c.hasProduct || !c.productHandle)
                        return !1;
                    var e, i = c.prefs,
                            n = "add-to-wishl",
                            s = a + "dropdown-toggle",
                            o = t(r),
                            l = t(1 === i.btn ? "<button/>" : '<a href="#"></a>'),
                            d = o.length > 0,
                            u = ":empty",
                            h = {},
                            f = [n, i.btn_class],
                            p = ["<span></span>"],
                            g = i.btn_show_multilist && c.canLogIn;
                    (!d || o.is(u)) && (c.loadCSS(), 8 < +i.btn_size && (h["font-size"] = i.btn_size), i.btn_icon && p.unshift(c.buttonIcon()), g && (e = t('<i class="' + s + ' wishl-icon icon-sort"></i>')), l.data("listId", c.wishlist.id).addClass(f.join(" ")).on("click", c.addItem).html(p.join(" ")).add(e).css(h), d && (o.filter(u).each(function (i, s) {
                        var a, o = t(s),
                                r = o.data("adder"),
                                d = !/atomic/.test(r),
                                u = "quickview" !== r,
                                h = l.clone(!0),
                                f = d && u && !o.data("noDropdown") && e;
                        h.toggleClass(n + "-main", d).data(o.data()), o.append(h, f), a = new c.selectedVariantId(h), c.setButtonStateAll(a.get(), h), d && a.watchVariantChange(), d && u && a.pollVariantChange()
                    }), g && c.createListsDropdown("." + s)))
                },
                setButtonState: function (e, i, n) {
                    function s() {
                        var e = a.btn_icon_color,
                                i = a.btn_icon_color_in,
                                n = t(this).hasClass("isin");
                        return n ? i : e
                    }
                    if (i && i.length) {
                        var a = c.prefs,
                                o = a.btn_icon,
                                r = -1 !== e,
                                l = 2 === e,
                                d = e === !0,
                                u = i.children(),
                                h = "togglable",
                                f = i.next(".wishl-dropdown");
                        i.data({
                            isInList: d
                        }), f.data(h) || "none" != f.css("display") ? f.data(h, !0) : f = "", i.add(f).toggle(r), r && o && u.eq(0).toggleClass("isin", d).toggleClass(o, !l).toggleClass("icon-adding fa-spin", l).css("color", s), n && u.last().html(d ? a.btn_text_in : a.btn_text)
                    }
                },
                setButtonStateAll: function (e, i) {
                    var n = ".add-to-wishl",
                            s = i ? i.parent() : "",
                            a = function (e, i) {
                                return +e ? t.inArray(+e, i) > -1 : -1
                            };
                    t(n, s).each(function (i, s) {
                        var o = t(s),
                                r = o.is(n + "-main"),
                                l = o.data("listId") || c.wishlist.id,
                                d = c.allItems[l] || 0,
                                u = d ? a(e, d) : !1,
                                h = r || /with_text/.test(o.data("adder"));
                        c.setButtonState(u, o, h)
                    })
                },
                createListsDropdown: function (e) {
                    var i, s, a = "wishl-dropdown",
                            o = a + "-backdrop",
                            r = "data-toggle",
                            l = "click",
                            d = "open",
                            u = t(e),
                            h = u.data("listAction");
                    if (i = function (e) {
                        e && 3 === e.which || (t("." + o).remove(), t("[" + r + '="' + a + '"]').each(function () {
                            var i = t(this),
                                    n = i.parent();
                            n.hasClass(d) && (e && e.type == l && /input|textarea/i.test(e.target.tagName) && t.contains(n[0], e.target) || e && e.isDefaultPrevented() || i.trigger(l))
                        }))
                    }, s = function () {
                        var e = t(this),
                                s = e.parent(),
                                r = s.find("." + a + "-lists:first"),
                                c = s.hasClass(d);
                        return r.children().length && (c || ("ontouchstart" in n.documentElement && t(n.createElement("div")).addClass(o).insertAfter(t(this)).on(l, i), e.trigger("focus")), r.toggle(), s.toggleClass(d)), !1
                    }, h = "move" == h ? h : "add", u.attr(r, a).wrap('<div class="' + a + '"></div>').after('<ul class="' + a + '-lists"></ul>').on(l, s).next("ul").each(function (t, e) {
                        return c.lists.dropdown(h, e)
                    }).on(l, "li>a.add-to-wishl", c[h + "Item"]), t(n).on(l, i), "add" === h) {
                        var f = new c.selectedVariantId(u);
                        c.setButtonStateAll(f.get(), u)
                    }
                },
                resizeImage: function (t, e) {
                    if (null == e)
                        return t;
                    if ("master" == e)
                        return t.replace(/http(s)?:/, "");
                    var i = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
                    if (null != i) {
                        var n = t.split(i[0]),
                                s = i[0];
                        return (n[0] + "_" + e + s).replace(/http(s)?:/, "")
                    }
                    return null
                },
                getItems: function (e) {
                    var n, s, a, r, l, d, u = (c.shown, c.allItems),
                            h = c.wishlist.id || !1,
                            f = 10,
                            p = i.location.hash,
                            g = /page=(\d+)/,
                            m = p.match(g);
                    if (c.onWishlist) {
                        e = e || {}, r = e.switchList, n = e.page, n || (c.showTitle(), c.addSaveTab(), c.sharingTab(), !r && c.lists.multilist().addNewListTab(), n = !r && m ? m[1] : 1), n = +n, l = f * (n - 1), c.shown = 0;
                        for (s in u)
                            h === +s && (a = u[s].length, n > 1 && l >= a && (n = 1, l = 0), c.itemsQueue = t.extend([], u[s].slice(l, l + f)));
                        a > 0 ? (d = Math.ceil(a / f), c.pagination = {
                            page: n,
                            limit: f,
                            offset: l,
                            total_pages: d,
                            prev_page: n > 1 ? n - 1 : 0,
                            next_page: d > n ? n + 1 : 0
                        }, c.processItemsList(), m && +m[1] !== n && (i.location.hash = p.replace(g, "page=" + n))) : c.setLoadingState(0), t(o).trigger("listload.wishl")
                    }
                },
                removeQueueItem: function (t) {
                    for (var e = 0, i = c.itemsQueue.length; i > e; e += 1)
                        if (t === c.itemsQueue[e].id)
                            return c.itemsQueue.splice(e, 1), !0
                },
                getShopProduct: function (e, i, n) {
                    return i && !n && (n = c.ajax("/products/" + i + ".js")), n && e && n.done(function (t) {
                        c.showItem(t, e)
                    }).fail(function (i, n, s) {
                        var a = e.id;
                        a && (404 === i.status && (c.removeItem(a), c.removeQueueItem(a)), t("#wishl-item-" + a).remove()), c.err(i, n, s)
                    }), n
                },
                showItem: function (e, i) {
                    var n = e.variants,
                            s = n.length,
                            a = 0;
                    for (c.removeQueueItem(i.id); s > a; a += 1)
                        if (n[a].id === i.variantid)
                            return c.renderItem(i, e, n[a]), c.itemsQueue.length || (c.setItemHandlers(), c.revertHbs(), c.setPagination(), c.setLoadingState(1), t(o).trigger("listcomplete.wishl")), !0;
                    s && e.id === i.productid && c.removeItem(i.id)
                },
                renderItem: function (e, i, n) {
                    var s, a, o, r, l, d, u, h, f;
                    return s = "wishl-item-" + e.id, a = t("#" + s), o = c.prefs, r = i.variants.length > 1, l = !!c.wishlist.token, d = c.lists.all.length > 1, u = [], h = new Date(e.created_at), a.length ? (r && o.show_variant_option && (u = c.itemVariantOptions(i, n.options)), f = {
                        itemId: e.id,
                        divId: s,
                        product: i,
                        variant: n,
                        item: e,
                        variantTitle: r ? n.title : "",
                        variantPrice: c.formatMoney(n.price),
                        comparePrice: c.formatMoney(n.compare_at_price),
                        priceClass: o.price_class || "price",
                        featuredImage: c.featuredImage(i, n, "large"),
                        variantOptions: u,
                        showAddToCart: c.itemAddToCartLabel(n),
                        showSoldOut: o.show_sold_out && c.t("item_sold_out"),
                        deleteLabel: l && (c.t("item_delete") || o.delete_text),
                        canMoveItem: d,
                        lang: {
                            move: c.t("move")
                        },
                        dateAdded: h.toLocaleDateString(),
                        timeAdded: h.toLocaleTimeString()
                    }, a.replaceWith(c.jst.item(f)), c.renderNote(e.id, "item", e.note), c.shown++, a) : !1
                },
                setItemHandlers: function () {
                    function e(e, i) {
                        var n;
                        return n = !!t(this).text() === /populated/.test(i), n ? "" : "populated"
                    }

                    function i() {
                        var e, i, n;
                        return e = t(this), i = e.data("item"), n = c.t("item_delete") || c.prefs.delete_text, n += " " + e.data("itemTitle") + "?", confirm(n) && c.removeItem(i), !1
                    }

                    function n() {
                        var e, i;
                        return e = t(this), i = e.prev(h), e.add(i).hide().next(u).show(), !1
                    }

                    function s() {
                        var e, i, n, s, a, d, u;
                        return e = t(this), i = e.closest(l), n = i.data(), s = t(l + "-input", i).val(), a = e.is(r + "save"), u = this, d = function (t) {
                            o.call(u, t)
                        }, a || d(), a && c.setNote(n.type, n.item, s, d), !1
                    }

                    function o(i) {
                        var n, s, a, o;
                        n = t(this).closest(l), s = t(h, n), a = t(d, n), o = [c.t("note_edit"), c.t("note_add")], t(l + "-form", n).hide(), s.toggleClass(e).add(a).show(), i && (s.text() && (o = o.reverse()), a.html(function (t, e) {
                            return String.prototype.replace.apply(e, o)
                        }))
                    }
                    var r = "." + a,
                            l = r + "note",
                            d = l + "-edit",
                            u = l + "-form",
                            h = l + "-content",
                            f = "click",
                            p = !!c.wishlist.token,
                            g = c.lists.all.length > 1;
                    t(h).toggleClass(e), p && t(r + "del").on(f, i), g && c.createListsDropdown(r + "move-item"), p && c.prefs.allow_notes ? (t(d).on(f, n), t(u).on(f, r + "cancel," + r + "save", s)) : t(d).add(u).remove()
                },
                featuredImage: function (t, e, i) {
                    var n, s;
                    return s = "featured_image", n = (e[s] || {}).src || t[s], n && c.resizeImage(n, i) || ""
                },
                itemVariantOptions: function (t, e) {
                    for (var i = [], n = 0, s = e.length; s > n; n++)
                        i[n] = {
                            name: t.options[n].name,
                            value: e[n]
                        };
                    return i
                },
                itemAddToCartLabel: function (t) {
                    var e = c.prefs;
                    return e.show_addtocart_btn && t.available && (c.t("item_add_to_cart") || e.add_to_cart_text)
                },
                formatMoney: function (t, e) {
                    if (!t)
                        return "";
                    var i, n, s, a, o, r = .01 * t,
                            l = "{{amount}}",
                            e = e || c.prefs.money_format || "$" + l,
                            d = /no_decimals/.test(e),
                            u = /with_comma_separator/.test(e),
                            h = ".",
                            f = ",",
                            p = -3;
                    for (s = r.toFixed(2).toString().split(h), a = s[0].split(""), o = - 1 * a.length; p > o; )
                        a.splice(p, 0, u ? h : f), o -= 1, p -= 4;
                    return s[0] = a.join(""), i = d ? s[0] : s.join(u ? f : h), n = e.replace(/\{\{amount[a-z_]*\}\}/, i)
                },
                processItemsList: function () {
                    var t, e, i = c.itemsQueue,
                            n = 0,
                            s = i.length,
                            a = {},
                            o = c.wishlist;
                    if (!c.handlebars_ready)
                        return !1;
                    if (s > 0)
                        for (c.wrapper.addClass("grid-uniform").empty(), c.setLoadingState(); s > n; n += 1)
                            t = i[n], e = t.handle, c.wrapper.append('<div class="product grid-item" id="wishl-item-' + t.id + '" />'), a[e] = c.getShopProduct.apply(null, [t, e, a[e]]);
                    o.id && c.renderNote(o.id, "wishlist", o.note)
                },
                setPagination: function () {
                    var e, i, n, s = c.pagination,
                            a = "wishl-pagination",
                            o = "#" + a,
                            r = function () {
                                var e;
                                return c.shown > 0 && (e = this.href.match(/page=([0-9]+)/)[1]) && (c.upgradeHbs(), c.getItems({
                                    page: e
                                }), t("html, body").animate({
                                    scrollTop: c.wrapper.offset().top - 80
                                }, 50)), !0
                            },
                            l = "#page=",
                            d = ' <a href="' + l,
                            u = '" class="wishl-';
                    s && (e = s.total_pages) > 1 ? (i = s.prev_page, n = s.next_page, t(o).length ? (console.log("Wishl Pagination obj", s), t(o + ">b").html(s.page), t(o + ">span").html(e), t(o + ">a").attr("href", function (t) {
                        return l + (t ? n : i)
                    })) : c.wrapper.after('<div id="' + a + '">' + c.t("page") + ":" + d + i + u + 'prev">&lt;</a> <b>' + s.page + "</b> / <span>" + e + "</span>" + d + n + u + 'next">&gt;</a></div>'), t(o).children("a").click(r).first().toggle(i > 0).end().last().toggle(n > 0)) : t(o).remove()
                },
                showTitle: function () {
                    var e, i = c.wishlist.title || c.t("list_default_title") || c.prefs.default_title,
                            n = "wishl-title",
                            s = "#" + n,
                            a = t(s);
                    return a.length < 1 && (t("h1:last").replaceWith('<div><h1 id="' + n + '"></h1></div>'), a = t(s), c.wishlist.token && (a.css({
                        display: "inline-block",
                        paddingRight: 12
                    }), e = t('<a href="#" id="' + n + '-edit">' + c.t("edit_title") + "</a>").insertAfter(a), "none" != e.css("display") && e.hide().add(a).hover(function () {
                        e.toggle()
                    }), a.add(e).click(function () {
                        var t = c.wishlist.title,
                                e = prompt(c.t("prompt_list_title_edit", t), t);
                        return e && e !== t && (a.addClass("wishl-working"), c.rename(e)), !1
                    }))), a.html(i)
                },
                renderNote: function (e, i, n) {
                    var s, o, r = {
                        type: i,
                        id: e,
                        note: n,
                        lang: {}
                    },
                    l = "note",
                            d = a,
                            u = "." + d,
                            h = "#" + d + "item-" + e,
                            f = [l + "_add", l + "_edit", "cancel", "save", l],
                            p = f.length - 1;
                    if (c.prefs.allow_notes) {
                        for (c.jst.note || (c.jst.note = WishlApp.Handlebars.templates.note); p >= 0; p--)
                            o = f[p], r.lang[o] = c.t(o);
                        s = c.jst.note(r), "item" === i ? t(u + "product-info", h).append(s) : "wishlist" === i && t("#" + d + "title").parent("div").find(u + l).remove().end().append(s)
                    }
                },
                addSaveTab: function () {
                    var e = "wishl-save-email",
                            i = "#" + e,
                            n = t(i),
                            s = c.wishlist;
                    s && s.token && !s.customer_id && c.canLogIn && !c.loggedIn() ? n.length < 1 && (n = t('<div id="' + e + '">' + c.t("log_in_save_list", c.loginLink) + "</div>").hide(), c.controls.addTab(c.t("save"), i, n, "plus").toggleTab(!c.prefs.default_tab && i)) : n.add("#" + c.controls.id + "-save").hide()
                },
                statusMsg: function (e, i, n, s, o) {
                    var r = e ? 2 === e ? "warn" : "success" : "error",
                            l = a + r,
                            d = (e ? "form-" + r : r + "s") + " ",
                            u = "." + l,
                            h = a + "message",
                            f = t("#" + h);
                    n || (n = f.length < 1 ? t('<div id="' + h + '"></div>').insertBefore(c.wrapper) : f), (!i || s) && t(u, n).remove(), i && (t(n).prepend('<div class="' + d + l + '">' + i + "</div>"), o && setTimeout(function () {
                        t(u, n).fadeOut()
                    }, 5e3))
                },
                clearMsg: function () {
                    for (var t = 0; 2 > t; t++)
                        c.statusMsg(t, null, c.wrapper.siblings())
                },
                loadCSS: function () {
                    if (!c.cssLoaded) {
                        var e = "//d1bjos7vh42dxe.cloudfront.net/assets/wishl-default-18c20290d320950efb86057d2feea19b945dcaad3d7760689de79f1be491aaef.css";
                        t("head").eq(0).append('<link rel="stylesheet" type="text/css" href="' + c.asset_host + e + '">'), c.cssLoaded = !0
                    }
                },
                loadHandlebars: function () {
                    if (!c.handlebars_ready) {
                        i.WishlApp = i.WishlApp || {};
                        var n, s = function () {
                            return "undefined" != typeof WishlApp.Handlebars
                        },
                                a = s() && parseFloat(WishlApp.Handlebars.VERSION) >= 3,
                                o = a && "function" == typeof WishlApp.Handlebars.compile,
                                r = c.asset_host + "//d1bjos7vh42dxe.cloudfront.net/assets/wishl-templates.runtime-db96dc5f6d1ddcca302a0228e0975829c153fcd634bb7617749005deaab048c6.js",
                                l = function (t) {
                                    c.jst.item = t, c.handlebars_ready = !0, c.processItemsList()
                                },
                                d = t("#wishl-item-template").html() || null;
                        return n = function () {
                            if (!s())
                                return void console.log("Wishl: Handlebars undefined");
                            if (d) {
                                var t = WishlApp.Handlebars.compile(d);
                                l(t)
                            } else
                                c.jst.item || l(WishlApp.Handlebars.templates.list_item)
                        }, d && (d = d.replace(/\/\/\s*(<\!\[CDATA\[|\]\]>)/g, ""), o || (a = !1, r = c.asset_host + "//d1bjos7vh42dxe.cloudfront.net/assets/wishl-templates-1435c231f6461195cac04d42790dbc8805a07b857930680145c7dcc5fbfc9420.js")), c.loadCSS(), a ? n() : e(r, n), a
                    }
                },
                upgradeHbs: function () {
                },
                revertHbs: function () {
                },
                setLoadingState: function (e, i) {
                    var n, s, a = "wishl-loading",
                            o = t("#" + a),
                            r = !0,
                            l = "grid-item",
                            d = "rte";
                    switch (e) {
                        case 1:
                            r = !1;
                            break;
                        case 0:
                            i = c.t("list_no_items") + '<br><br><a href="' + (c.prefs.continue_shopping_href || "/") + '">' + c.t("list_continue_shopping") + "</a> ", c.canLogIn && !c.loggedIn() && (i += c.t("list_or_log_in_view_saved", c.loginLink)), o.html(i).siblings().add("#wishl-pagination").remove();
                            break;
                        default:
                            s = t(c.wrapper), s.length < 1 && (n = t("h1:last").parent(), n.length > 0 && (s = t('<div id="' + c.wrapper.substr(1) + '"/>'), 1 === n.children().length ? s.insertAfter(n) : s.appendTo(n))), c.wrapper = s, o.length < 1 && (s.prepend('<p id="' + a + '">' + c.t("list_loading") + "</p>"), s.closest("." + l).attr("class", l), s.closest("." + d).removeClass(d), c.controls.build())
                    }
                    return o.toggle(r)
                },
                controls: {
                    id: "wishl-controls",
                    build: function () {
                        var e = this.id,
                                i = t("#" + e),
                                n = "click";
                        i.length < 1 && (i = t('<div id="' + e + '"/>').append("<ul/>").insertBefore(c.wrapper), i.off(n, "li").on(n, "li", function () {
                            var e, n = t(this),
                                    s = t(n.data("showTab")),
                                    a = "active",
                                    o = i.children("div"),
                                    r = 200;
                            return n.hasClass(a) ? e = n : s.length > 0 && (o = o.not(s), t(s).show(r), e = n.addClass(a).siblings()), e && (o.hide(r), e.removeClass(a)), !1
                        }))
                    },
                    addTab: function (e, i, n, s) {
                        var a = "#" + this.id,
                                o = "wishl-tab",
                                r = o + " " + this.id + "-" + e.toLowerCase().replace(/[^0-z-_]/gi, ""),
                                l = s ? '<i class="wishl-icon icon-' + s + '"></i> ' : "";
                        return n && t(n).addClass(o + "-content").appendTo(a), t("<li/>").html(l + e).addClass(r).data({
                            showTab: i
                        }).appendTo(t(a + ">ul")), this
                    },
                    toggleTab: function (e) {
                        return t(".wishl-tab").filter(function () {
                            return t(this).data("showTab") === e
                        }).click(), this
                    }
                },
                sharingTab: function (n) {
                    var s, o = a + "share-buttons",
                            r = "#" + o,
                            l = !0,
                            d = a + "share-url",
                            u = "addthis:url",
                            h = c.wishlist,
                            f = [c.app_host, "shared-list", h.id, h.share_token].join("/"),
                            p = !/goo\.gl\//.test(h.short_url) && h.short_url,
                            g = n || !p ? f : p,
                            m = c.prefs.sharing_message || h.title,
                            _ = c.controls,
                            v = "wishl-shorten-url",
                            w = function () {
                                var t = !this.checked;
                                t !== n && c.sharingTab(t)
                            },
                            b = function () {
                                var t = (c.prefs.twitter_handle || "").replace("@", "");
                                i.addthis_config = i.addthis_config || {}, i.addthis_share = i.addthis_share || {}, addthis_config.data_track_addressbar = !1, addthis_config.data_track_clickback = !1, addthis_share.url = g, i.addthis_url = g, addthis_share.title = m, t && (addthis_share.passthrough = {
                                    twitter: {
                                        via: t
                                    }
                                })
                            };
                    h.id && (t(r).length < 1 ? (_.addTab(c.t("tab_share"), r, '<div id="' + o + '"></div>', "share"), s = t('<div id="' + o + '-box"></div>'), t(r).hide().prepend(c.t("share_list_label"), s), "share" == c.prefs.default_tab && _.toggleTab(r), l && (s.addClass("addthis_sharing_toolbox").attr(u, g), e("//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-550d35687ea47b15", b)), t('<input type="text" id="' + d + '" readonly>').val(g).click(function () {
                        t(this).select()
                    }).appendTo(r), t('<label><input type="checkbox" id="' + v + '"> ' + c.t("shorten_link") + " <i></i></label>").appendTo(r)) : l && (b(), t(r).attr(u, g).data("url", g)), t("#" + d).val(g), t("#" + v).off("click").prop("checked", g === p).click(p ? w : c.shortenUrl))
                },
                shortenUrl: function () {
                    var e, i, n, s, a, o, r, l = t(this),
                            d = c.buildRequestUrl("wishlist", c.wishlist.id),
                            u = 1500,
                            h = 0;
                    l.off("click", c.shortenUrl), a = function (t) {
                        var e = t.short_url;
                        return e ? (clearInterval(n), r(!1), l.is(":checked") && (c.wishlist.short_url = e, c.sharingTab()), !0) : !1
                    }, o = function () {
                        alert(c.t("shorten_link_error")), c.sharingTab(!0)
                    }, r = function (t) {
                        l.nextAll("i").toggleClass("wishl-icon icon-adding fa-spin", t)
                    }, s = function () {
                        var t, e;
                        e = function () {
                            h += 1, h >= 5 && (clearInterval(n), r(!1), o())
                        }, t = c.ajax(d + "/shortened_url", i), t.done(a), t.always(e)
                    }, i = {
                        store_id: c.getStoreId(),
                        share_token: c.wishlist.share_token
                    }, e = c.post(d + "/shorten_url", i), e.done(a), e.fail(o), r(!0), n = setInterval(s, u)
                },
                init: function () {
                    c.setDefaults();
                    var e = c.hasProduct,
                            i = c.onWishlist;
                    if (e || i) {
                        if (i && (c.loadHandlebars(), c.setLoadingState()), "object" == typeof shopify_customer_for_wishl) {
                            var n, a = shopify_customer_for_wishl,
                                    o = ["id", "email", "first_name"];
                            for (n in a)
                                a[n] !== s && t.inArray(n, o) > -1 && (c.customer[n] = a[n])
                        } else
                            "undefined" != typeof shopify_customer_accounts_disabled && (c.canLogIn = !1);
                        return c.getAll(i)
                    }
                }
            };
    "withCredentials" in new XMLHttpRequest ? c.init() : "undefined" != typeof XDomainRequest && c.setDefaults() && (c.hasProduct || c.onWishlist) && (c.xdr = 1, e(c.asset_host + "//d1bjos7vh42dxe.cloudfront.net/assets/jquery.xdomainrequest.min-v1.0.4.js", c.init)), c.onWishlist || t(n).on("ajaxSuccess", c.init)
};
(function () {
    !function (t, e) {
        var i, n, s;
        return s = function (t, i) {
            var n;
            return n = e.createElement("script"), n.type = "text/javascript", n.readyState ? n.onreadystatechange = function () {
                var t;
                return "loaded" === (t = n.readyState) || "complete" === t ? (n.onreadystatechange = null, i()) : void 0
            } : n.onload = function () {
                return i()
            }, n.src = t, e.getElementsByTagName("head")[0].appendChild(n)
        }, n = function () {
            var t;
            return "undefined" == typeof jQuery ? !0 : (t = jQuery.fn.jquery, 1 === parseInt(t) && parseFloat(t.replace(/^1\./, "")) < 7.1)
        }, n() ? (i = function () {
            return t.jQueryWishl = jQuery.noConflict(!0), wishlAppJavaScript(t.jQueryWishl, s, t, e)
        }, s("//ajax.googleapis.com/ajax/libs/jquery/1.11.1/jquery.min.js", i)) : wishlAppJavaScript(jQuery, s, t, e)
    }(window, document)
}).call(this);